import { render, staticRenderFns } from "./AdvertisementVisual.vue?vue&type=template&id=5afd5ba8&"
import script from "./AdvertisementVisual.vue?vue&type=script&lang=js&"
export * from "./AdvertisementVisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports